<template>
  <header
    class="sticky top-0 z-20 flex items-center justify-between border-b border-gpx_gray-900 bg-white px-3 py-1.5 md:relative md:px-6 md:py-1.5"
  >
    <div class="flex items-center justify-between sm:mr-6">
      <router-link v-if="isLoggedIn" to="/">
        <AppLogo class="max-w-none" :shareable-link-logo="shareableLinkLogo" />
      </router-link>
      <AppLogo
        v-else
        class="max-w-none"
        :shareable-link-logo="shareableLinkLogo"
      />
    </div>
    <template v-if="!isGpxAdminPage">
      <NavMobileNavigationButton
        v-if="isLoggedIn"
        :isOpen="isMobileNavOpen"
        @setOpen="setIsMobileNavOpen(!isMobileNavOpen)"
      />
      <NavDesktopNavigation v-if="isLoggedIn" />
    </template>
    <template v-if="!isGpxAdminPage">
      <NavMobileNavigation
        v-if="isLoggedIn && isMobileNavOpen"
        @setOpen="setIsMobileNavOpen"
      />
    </template>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AppLogo from './AppLogo.vue';
import NavMobileNavigationButton from './nav/NavMobileNavigationButton.vue';
import NavDesktopNavigation from './nav/NavDesktopNavigation.vue';
import NavMobileNavigation from './nav/NavMobileNavigation.vue';
import { isRouteForGpxAdmin } from '@/utils/rules';

export default {
  components: {
    NavMobileNavigationButton,
    NavDesktopNavigation,
    NavMobileNavigation,
    AppLogo,
  },

  props: {
    shareableLinkLogo: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      isMobileNavOpen: 'settings/isMobileNavOpen',
      isLoggedIn: 'auth/check',
    }),
    isGpxAdminPage() {
      return isRouteForGpxAdmin(this.$route);
    },
  },

  methods: {
    ...mapActions({
      setIsMobileNavOpen: 'settings/setIsMobileNavOpen',
    }),
  },
};
</script>
